module.exports = __webpack_public_path__ + "img/alarmImg1.30491bd7.png";